import React from 'react'
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
// import "/node_modules/cropperjs/dist/cropper.min.css";
import "cropperjs/dist/cropper.min.css";
import {iconImage, iconUpload} from "../../assetsSQFT";
import {SLAB_IMAGE_TYPES} from "../../../../reducers/sqft/sqftSlabReducer";
import {setSlabImageType} from "../../../../actions/sqftSlabFunctions";

const SqftStepSelectImageType = (props) => {
  const {slabImageType, setSlabImageType} = props;

  const handleRectClick = (imageType) => {
    setSlabImageType(imageType)
  }

  return (
    <div className={"slab-content "}>
      <div className="slab-image-type">
        <div className={"slab-image-type__rect " + (slabImageType === SLAB_IMAGE_TYPES.placeholder ? "slab-image-type__rect-active" : "")}
          onClick={() => handleRectClick(SLAB_IMAGE_TYPES.placeholder)}>
          <img src={iconImage} alt="" className="slab-image-type__icon"/>
          <FormattedMessage id={"sqft.popup.slab.usePlaceholderMessage"}/>
        </div>
        <div className={"slab-image-type__rect " + (slabImageType === SLAB_IMAGE_TYPES.upload ? "slab-image-type__rect-active" : "")}
             onClick={() => handleRectClick(SLAB_IMAGE_TYPES.upload)}>
          <img src={iconUpload} alt="" className="slab-image-type__icon"/>
          <FormattedMessage id={"sqft.popup.slab.uploadSlabMessage"}/>
        </div>
      </div>

    </div>
  )
};

const mapStateToProps = (store) => ({
  slabImageType: store.sqftSlabState.slabImageType,
});

const mapDispatchToProps = {
  setSlabImageType,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftStepSelectImageType)
)

